import { IMember, IMemberResult } from './../models/member';
import { IOrganization } from './../models/organization';
import {
  UpdatePasswordRequest,
  PasswordResult,
  UpdateEmailRequest,
} from './user.model';

export namespace User.Actions {
  export class SetCurrentFirebaseUser {
    public static readonly type = '[User] SetCurrentFirebaseUser';
    constructor(public email: string) {}
  }

  export class SetCurrentUser {
    public static readonly type = '[User] SetCurrentUser';
    constructor(public user: IMember) {}
  }

  export class GetLoginInformation {
    public static readonly type = '[User] GetLoginInformation';
    constructor(public email: string) {}
  }

  export class SetLoginInformation {
    public static readonly type = '[User] SetLoginInformation';
    constructor(public memberOrganization: IMemberResult) {}
  }

  export class UpdatePassword {
    public static readonly type = '[User] UpdatePassword';
    constructor(public value: UpdatePasswordRequest) {}
  }

  export class UpdatePasswordResult {
    public static readonly type = '[User] UpdatePassword Success';
    constructor(public result: PasswordResult) {}
  }
  export class UpdateUsername {
    public static readonly type = '[User] UpdateUsername';
    constructor(public value: UpdateEmailRequest) {}
  }

  export class UpdateUsernameResult {
    public static readonly type = '[User] UpdateUsername';
    constructor(public result: PasswordResult) {}
  }

  export class SetCurrentOrganization {
    public static readonly type = '[User] UpdatePassword';
    constructor(public organization: IOrganization) {}
  }

  export class GetCurrentUserByEmailId {
    public static readonly type = '[User] GetCurrentUserById';
    constructor(public userEmail: string) {}
  }

  /** TODO */
  export class GetCurrentOrganizationById {
    public static readonly type = '[User] GetCurrentOrganizationById';
    constructor(public organizationId: string) {}
  }

  /** TODO */
  export class GetOrganizationsByUser {
    public static readonly type = '[User] GetOrganizationsByUser';
    constructor(public userId: string) {}
  }
}
